import * as signalR from "@microsoft/signalr";

class SignalRService {
  constructor() {
    this.connection = null;
  }

  async start() {
    if (
      this.connection &&
      this.connection.state === signalR.HubConnectionState.Connected
    ) {
      return this.connection;
    }

    // Remove /api from BASE_URL
    const hubUrl = window.env.BASE_URL.replace("/api", "") + "/NotificationHub";

    console.log("SignalR hub URL:", hubUrl);

    this.connection = new signalR.HubConnectionBuilder()
      .withUrl(hubUrl)
      .withAutomaticReconnect([0, 2000, 5000, 10000])
      .configureLogging(signalR.LogLevel.Information)
      .build();

    this.connection.onreconnecting(() => {
      console.log("SignalR Reconnecting...");
    });

    this.connection.onreconnected(() => {
      console.log("SignalR Reconnected");
    });

    this.connection.onclose(() => {
      console.log("SignalR Closed");
    });

    await this.connection.start();

    console.log("SignalR Connected");

    return this.connection;
  }

  getConnection() {
    return this.connection;
  }

  async stop() {
    if (this.connection) {
      await this.connection.stop();
    }
  }
}

export default new SignalRService();
